$(function () {
    $('[data-input-vis-toggle]').each(function () {
        var self = $(this);
        var target = $('#' + self.data("input-vis-toggle"));
        self.on('click', function (e) {
            e.preventDefault();
            if (target.prop("type") === "password") {
                target.prop("type", "text")
            } else {
                target.prop("type", "password")
            }
        })
    });
})
